import React, {useState} from 'react'
import './FloatOptions.css'
import AddFamilyModal from './AddFamilyModal'

function FloatOptions() {
    const [displayOption, setDisplayOption] = useState(false);
    const [addFamily, setDisplayFamilyOption] = useState(false);
    const [addRelative, setDisplayRelativeOption] = useState(false);
  return (
    <div className='schedulebtn_parent'>
        <div className='schedulebtn_float'>
            
            {/* If display option is False then only show hint text */}
            {displayOption ? 
                null
                :
                <p className='schedluebtn_hint'>
                    Add Families and Friends
                </p>
            }

            <i class={displayOption ? "fa fa-times schedule-float-plus":"fa fa-plus schedule-float-plus"} 
                onClick={() => setDisplayOption(!displayOption)} aria-hidden="true"
                style={{transition: '1s ease',}}
            >
            </i>

            
        </div>

        <div className='schedulebtn_options'>
            <button className='schedulebtn_option1' onClick={() => setDisplayRelativeOption(true)} style={displayOption ? {width:'95px', height:'40px',borderRadius: '5px', right:'18px',bottom:'100px' ,transition:'2s ease', opacity:1}: {transition:'1s ease'}} >Add Relative</button> {/* onClick={() => {setHandletodo(true);setDisplayOption(false)}} */}
            <button className='schedulebtn_option2' onClick={() => setDisplayFamilyOption(true)} style={displayOption ? {width:'90px', height:'40px',borderRadius: '5px', right:'20px',bottom:'150px', transition:'1.5s ease', opacity:1}:  {transition:'1.5s ease'}}>Add Family</button>

            <p className='schedluebtn_hint_optionbtn1' style={displayOption ? {display: 'block'} : null}>Create/Add Family Members</p>
            <p className='schedluebtn_hint_optionbtn2' style={displayOption ? {display: 'block'} : null}>Add Relatives and friends</p>
            
        </div>

        {addFamily ?

            <div className='addfamily_modal_toggle'>                  
                <div className='addfamily_modal_close' onClick={() => setDisplayFamilyOption(false)}></div>
                <AddFamilyModal type='my_family' onCloseHandler={() => setDisplayFamilyOption(false)} />
            </div>
        :
            null
        }

        {addRelative ?

            <div className='addfamily_modal_toggle'>                  
                <div className='addfamily_modal_close' onClick={() => setDisplayRelativeOption(false)}></div>
                <AddFamilyModal type='my_relative' onCloseHandler={() => setDisplayRelativeOption(false)} />
            </div>
        :
            null
        }
    </div>
  )
}

export default FloatOptions